// Central content + assets for the DóRéMigos landing page
export const IMAGES = {
  heroGang: "/img/hero-gang.jpg",
  bookSpread: "/img/book-spread.jpg",
  backpacksWall: "/img/backpacks-wall.jpg",
  playArea: "/img/play-area.jpg",
  apparel: "/img/apparel.jpg",
  stationery: "/img/stationery.jpg",
  party: "/img/party.jpg",
  kidSinging: "/img/kid-singing.jpg",
};

export const NAV = [
  { label: "Universo", href: "#universo" },
  { label: "Pilares", href: "#pilares" },
  { label: "A turma", href: "#turma" },
  { label: "Rota", href: "#rota" },
];

export const TICKER = [
  "PUBLISHING", "PELÚCIAS PREMIUM", "MOCHILAS-PERSONAGEM", "VESTUÁRIO",
  "PAPELARIA", "ÁREAS KIDS", "EVENTOS IMERSIVOS", "MÚSICA ORIGINAL",
];

export const MANIFESTO = [
  {
    n: "01",
    from: "Tela que embala",
    to: "Corpo que participa",
    color: "#FF4D85",
  },
  {
    n: "02",
    from: "Scroll sem fim",
    to: "História com começo, meio e fim",
    color: "#FF7A00",
  },
  {
    n: "03",
    from: "Consumo passivo",
    to: "Ritmo, escuta e cooperação",
    color: "#00D1FF",
  },
  {
    n: "04",
    from: "Personagem genérico",
    to: "Amigo com nome e voz",
    color: "#9D4EDD",
  },
];

export const CHARACTERS = [
  { name: "Guita", instrument: "Guitarra elétrica", trait: "Energia que puxa a roda", color: "#FF4D85", dark: false },
  { name: "TumTum", instrument: "Tambor", trait: "O coração do ritmo", color: "#FF7A00", dark: false },
  { name: "Keys", instrument: "Teclado", trait: "Curioso e inventivo", color: "#FFD600", dark: true },
  { name: "Vox", instrument: "Microfone", trait: "A voz que acolhe", color: "#00D1FF", dark: true },
  { name: "Vi", instrument: "Violino", trait: "Sensível e sonhadora", color: "#9D4EDD", dark: false },
  { name: "Tam", instrument: "Pandeiro", trait: "Festa em pessoa", color: "#00E676", dark: true },
];

export const APPLIED = [
  { label: "Vestuário", desc: "Pijamas, camisetas e coordenados", img: IMAGES.apparel, rot: "-3deg" },
  { label: "Papelaria", desc: "Cadernos, kits escolares e stickers", img: IMAGES.stationery, rot: "2.5deg" },
  { label: "Kits de festa", desc: "Mesa completa da turma", img: IMAGES.party, rot: "-1.5deg" },
];

export const ROADMAP = [
  { phase: "Fase 01", title: "Narrativa", desc: "Base da marca e identidade dos personagens.", color: "#FF4D85" },
  { phase: "Fase 02", title: "Produto", desc: "Pelúcias, mochilas e vestuário com parceiros licenciados.", color: "#FF7A00" },
  { phase: "Fase 03", title: "Experiência", desc: "Áreas kids e eventos imersivos em shoppings.", color: "#00D1FF" },
  { phase: "Fase 04", title: "Escala", desc: "Conteúdo audiovisual, música e expansão internacional.", color: "#9D4EDD" },
];
